import parse from 'html-react-parser';

import ApiState from '@/components/ApiState/ApiState';
import ChapterNav from '@/components/ChapterNav/ChapterNav';
import Layout from '@/components/Layout/Layout';
import Link from '@/components/LangLink/LangLink';
import NavLabel from '@/components/NavLabel/NavLabel';
import Overlay from '@/components/Overlay/Overlay';
import { parseRelatedSectionIds } from '@/utils/jsonUtils';
import { useNavigationStore } from '@/store/useNavigationStore';
import { useAdjacentPages } from '@/store/useAdjacentPages';
import { useBasicPage, useTimelineChildren } from '@/api/useThesaurusTerm';

import segellsColor from '@/assets/img/overlays/segells-color@2x.png';
import mapImg from '@/assets/img/mapa-maria-luisa-elio@2x.png';

function Chapter({ page }) {
    const { data, isLoading, error } = useBasicPage(page.section_id);
    const { title, abstract } = data?.[0] ?? {};

    const {
        data: childrenData,
        isLoading: childrenLoading,
        error: childrenError,
    } = useTimelineChildren();

    const pages = useNavigationStore((s) => s.pages);
    const { prev, next } = useAdjacentPages(page.web_path);

    return (
        <Layout>
            <title>{page.term}</title>
            <div className="overlay-space is-hidden-touch">
                <Overlay
                    src={segellsColor}
                    style={{
                        top: -28,
                        left: '55%',
                        transform: 'translateX(-50%)',
                        zIndex: 8,
                        maxWidth: 386,
                        opacity: 0.8,
                    }}
                />
            </div>
            <ApiState isLoading={childrenLoading || isLoading} error={childrenError || error}>
                <div className="wrapper py-8">
                    <div className="columns">
                        <div className="column is-two-fifths-widescreen">
                            <h1 className="has-text-primary is-uppercase is-family-secondary">
                                {title}
                            </h1>
                        </div>
                    </div>
                    <div className="columns is-widescreen">
                        <div className="column is-three-fifths-widescreen">
                            <figure className="timeline--sticky-map mt-2">
                                <img src={mapImg} alt="" className="radius" />
                                <figcaption className="is-size-6">{abstract}</figcaption>
                            </figure>
                        </div>
                        <div className="column is-two-fifths-widescreen">
                            <ol className="timeline flow--l">
                                {childrenData &&
                                    childrenData.length > 0 &&
                                    childrenData.map((item, i) => {
                                        const section_id = parseRelatedSectionIds(item.related)[0];
                                        const web_path = section_id
                                            ? pages.find((p) => p.section_id === section_id)
                                                  ?.web_path
                                            : undefined;
                                        return (
                                            <li
                                                key={'timeline-item-' + i}
                                                className="timeline-item full-link"
                                            >
                                                <h2 className="is-size-5">
                                                    {web_path ? (
                                                        <Link to={web_path} className="link-dn">
                                                            <NavLabel
                                                                primary={item.term}
                                                                secondary={item.title}
                                                                inline
                                                            />
                                                        </Link>
                                                    ) : (
                                                        <NavLabel
                                                            primary={item.term}
                                                            secondary={item.title}
                                                            inline
                                                        />
                                                    )}
                                                </h2>
                                                {item.abstract && (
                                                    <p className="is-size-6 has-text-weight-light">
                                                        {parse(item.abstract)}
                                                    </p>
                                                )}
                                            </li>
                                        );
                                    })}
                            </ol>
                        </div>
                    </div>

                    <ChapterNav prev={prev} next={next} />
                </div>
            </ApiState>
        </Layout>
    );
}

export default Chapter;
